<div class="row mb-3">
  <div class="col-12">
    <label>Extract Keywords from</label>
  </div>

  <div class="col-12">
    <p-checkbox
      name="fullOverview"
      (click)="onSelection()"
      [(ngModel)]="filter.fullOverview"
      [disabled]="readOnly || isNonBvdSelected"
      binary="true"
    ></p-checkbox>
    <label for="fullOverview" class="keywords-from-option">Full Overview</label>

    <p-checkbox
      name="tradeDescription"
      (click)="onSelection()"
      [(ngModel)]="filter.tradeDescription"
      [disabled]="readOnly || isNonBvdSelected"
      binary="true"
    ></p-checkbox>
    <label for="tradeDescription" class="keywords-from-option">Trade Description</label>

    <p-checkbox
      name="nativeLanguage"
      (click)="onSelection()"
      [(ngModel)]="filter.nativeLanguage"
      [disabled]="readOnly || isNonBvdSelected"
      binary="true"
    ></p-checkbox>
    <label for="nativeLanguage" class="keywords-from-option">Native Language</label>

    <span class="help-block" *ngIf="isNonBvdSelected">
      <span> Compustat & OneSource vendor data contains only Full Overview </span>
    </span>
  </div>
  <div class="col-12" *ngIf="formDirty && !isOptionSelected">
    <span class="help-block">
      <span> Please select an option </span>
    </span>
  </div>

  <input type="hidden" id="isOptionSelected" name="isOptionSelected" [ngModel]="isOptionSelected" required />
</div>

<div class="row mb-4">
  <div class="col-12">Custom Keywords</div>
  <div class="col-12" [ngClass]="{ 'has-error': (!booleanSearchInput.pristine || booleanSearchInput.touched) && !filter.booleanSearch }">
    <textarea
      class="form-control boolean-search"
      id="booleanSearchInput"
      name="booleanSearchInput"
      #booleanSearchInput="ngModel"
      maxlength="4000"
      minRows="10"
      appAutosize
      (ngModelChange)="keywordChanged($event)"
      [(ngModel)]="filter.booleanSearch"
      [disabled]="readOnly"
      required
      appKeywordsBooleanLogic
    ></textarea>
  </div>
  <div
    class="col-12"
    *ngIf="((!booleanSearchInput.pristine || booleanSearchInput.touched) && !filter.booleanSearch) || booleanSearchInput.errors?.booleanLogic"
  >
    <span class="help-block">
      <span> Please enter a valid Boolean Search </span>
    </span>
  </div>

  <div
    class="col-12 flex-grow-1 p-2 note"
    *ngIf="(!booleanSearchInput.pristine || booleanSearchInput.touched) && filter.booleanSearch && connectorCount >= 10"
  >
    <i class="material-icons">info</i>
    <span> You have used more than 11 keywords in a single filter - we recommend using another filter to extend the list of keywords </span>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <div>Custom Keywords Usage</div>
    <div class="keywords-usage">
      <p>
        For sake of efficiency, please do not include a list of keywords longer than 11 words in one filter. We recommend you using separate filters
        for function and product keywords and a separate filter for excluding keywords. If the amount of each filter exceed 11 words, it could take
        longer to run the search strategy. You can also consider to split the keywords into multiple filters for efficiency reasons.
      </p>
      <p>
        A search finds simple terms (i.e. a word or phrase or a prefix). Supported logical connectors are AND, AND NOT, OR or NEAR. The search for
        characters in the word or phrase is not case sensitive.
      </p>
      <p>
        <span class="bold">A word</span> is defined as a string of characters without spaces or punctuation. A word can be enclosed in double
        quotation marks but it is not necessary.".<br />
        <span class="bold">A phrase</span> is defined as two or more words with spaces between each word. Phrases should be enclosed in double
        quotation marks ("").<br />
        <span class="bold">A wildcard</span> of asterisk (*) can be used at the end of a word or phrase or by itself and must be enclosed by quotes.
      </p>
      <p>
        Word = “wine” or wine will act as an exact match and will return word wine.<br />
        Word = “wine*” will act as wildcard and will return words like wine or winery<br />
        Phrase = “local wine*” will return phrases like local winery or locally wined<br />
        By itself = "*" or * will return anything which is not null.
      </p>
    </div>
  </div>
</div>
